import { castArray, filter, find, isEmpty, isPlainObject } from 'lodash';
import { decodeString } from './decodeString';
export const getSelectedOptions = ({ isControlled, isCreatable, isMulti, options, selectedValue, }) => {
    if (!selectedValue ||
        (Array.isArray(selectedValue) && isEmpty(selectedValue))) {
        return isControlled ? null : undefined;
    }
    if (isMulti) {
        const selectedValueAsArray = castArray(selectedValue).filter(Boolean);
        if (isCreatable) {
            return selectedValueAsArray.map((selectedValue) => {
                var _a;
                return (_a = options.find(({ value }) => selectedValue === value)) !== null && _a !== void 0 ? _a : {
                    label: selectedValue,
                    value: selectedValue,
                };
            });
        }
        return filter(options, ({ id, label, value }) => selectedValueAsArray.some((selected) => {
            const selectedToCompare = selected.value || selected.id || selected.label || selected;
            return (selectedToCompare === value ||
                selectedToCompare === id ||
                selectedToCompare === label);
        }));
    }
    const match = find(options, ({ id, label, value }) => {
        const selectedValueToCompare = selectedValue.value ||
            selectedValue.id ||
            selectedValue.label ||
            selectedValue;
        return (value === selectedValueToCompare ||
            id === selectedValueToCompare ||
            label === selectedValueToCompare);
    });
    if (isCreatable) {
        return (match || {
            label: selectedValue,
            value: selectedValue,
        });
    }
    return match;
};
export const getOptionLabel = ({ label, name, text, title, }) => decodeString(label || name || text || title);
export const getOptionValue = ({ id, value }) => value || id;
export const formatOptions = ({ options }) => {
    if (isPlainObject(options)) {
        return Object.keys(options).map((optionKeyValue) => ({
            label: decodeString(options[optionKeyValue]),
            value: optionKeyValue,
        }));
    }
    return options.map((option) => {
        if (!isPlainObject(option)) {
            return {
                label: decodeString(option),
                value: option,
            };
        }
        return decodeString(option);
    });
};
//# sourceMappingURL=selectValues.js.map